import React, { FC, FormEvent } from 'react';
import PropTypes from 'prop-types';
import { Button, Input } from 'esa-ui-library';
import { Form, EMAIL_INVALID_MESSAGE } from '../../../..';
import { useStore } from '../../../../../common';

interface LogInFormProps {
	onSubmit: () => void;
	onForgot?: () => void;
}

const LogInForm: FC<LogInFormProps> = ({ onSubmit, onForgot }): JSX.Element => {
	const [state, dispatch] = useStore(true);
	const { email: initialEmail, password: initialPassword, two_step_code: initialTwoStepCode, errors, success } = state;

	const [email, setEmail] = React.useState(initialEmail);
	const [password, setPassword] = React.useState(initialPassword);
	const [twoStepCode, setTwoStepCode] = React.useState(initialTwoStepCode || '');

	React.useEffect(() => {
		setEmail(initialEmail);
	}, [initialEmail]);

	React.useEffect(() => {
		setPassword(initialPassword);
	}, [initialPassword]);

	React.useEffect(() => {
		setTwoStepCode(initialTwoStepCode || '');
	}, [initialTwoStepCode]);

	const isSubmitDisabled = !email || !password;

	const onEmailChange = (val: string) => {
		setEmail(val);
		dispatch('EMAIL', val);
	};

	const onPasswordChange = (val: string) => {
		setPassword(val);
		dispatch('PASS', val);
	};

	const onTwoStepCodeChange = (val: string) => {
		setTwoStepCode(val);
		dispatch('TWO_STEP_CODE', val);
	};

	const submitHandler = (e: FormEvent<HTMLFormElement>) => {
		e.preventDefault();
		onSubmit();
	};

	return (
		<Form errors={errors} success={success}>
			<form onSubmit={submitHandler}>
				<Input
					type='text'
					label='Email'
					value={email}
					placeholder='Enter your username or email here'
					dataId='email-field'
					onChange={onEmailChange}
					errorMessage={EMAIL_INVALID_MESSAGE}
				/>
				<Input
					type='password'
					label='Password'
					value={password}
					placeholder='Enter your password here'
					dataId='password-field'
					onChange={onPasswordChange}
				/>
				<Input
					type='number'
					label='Two step code'
					value={twoStepCode}
					placeholder='Enter your two step code here'
					dataId='two-step-code-field'
					onChange={onTwoStepCodeChange}
					name='two_step_code'
				/>
				<Button type='submit' title='Sign in' fluid primary disabled={isSubmitDisabled} dataId='login-button' />
				{onForgot && (
					<Button type='button' title='Forgot password' fluid teritary dataId='forgot-button' onClick={onForgot} />
				)}
			</form>
		</Form>
	);
};

LogInForm.propTypes = {
	onSubmit: PropTypes.func.isRequired,
	onForgot: PropTypes.func,
};

export { LogInForm };
